@if (!hideDebitStatus) {
  @if (!directDebitEnabled) {
    <div class="notification-bar warn" (click)="navigateTo('direct-debit')">
      <mat-icon svgIcon="exclamation_icon" class="exclamation-icon"></mat-icon>
      <span class="mat-body-medium red-text">Activate Direct Debit Today for Hassle-Free Payments! </span>
    </div>
  }
}

@if (showComplianceBanner) {
  <div class="notification-bar warn" (click)="openVaccinationModal()">
    <mat-icon svgIcon="exclamation_icon" class="exclamation-icon"></mat-icon>
    <span class="mat-body-medium red-text">{{ complianceBannerLabel }}</span>
  </div>
}

@if (showNotifications) {
  @for (notification of notifications; track notification) {
    <div class="notification-bar info" (click)="openDialog(notification)">
      <mat-icon>remove_red_eye</mat-icon>
      @if (!notification.vax) {
        <span class="mat-body-medium banner-title"
          [innerHTML]="notification.message.length < characters ? notification.message : notification.message.substring(0, characters) + '... '">
        </span>
      }
      @if (notification.vax) {
        <span class="mat-body-medium"
        [innerHTML]="notification.title.length < characters ? notification.title : notification.title.substring(0,characters) + '... '"></span>
      }
    </div>
  }
}

@if (headerImage) {
  <header class="page-header {{ extraClass }}" [style.background-image]="'url(' + headerImage + ')'">
    @if (imageSrc) {
      @if (imageLink) {
        <a href="{{ imageLink }}">
          <img img src="{{ imageSrc }}" alt="{{ imageAlt }}" />
        </a>
      }
      @if (!imageLink) {
        <img img src="{{ imageSrc }}" alt="{{ imageAlt }}" />
      }
    }
    <div class="page-header_curve"></div>
  </header>
}